export const ALPHABET_AND_NUMBER =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890"
    .split("")
    .concat("Backspace");

export const ONLY_NUMBER = "1234567890".split("").concat("Backspace");
